module.exports = __webpack_public_path__ + "images/psp/CTA/imagespace.webp";